export let storageDateFormat = 'YYYYMMDDHHmm';
export let displayDateFormat = 'DD.MM.YYYY';
export let longDisplayDateFormat = 'DD.MM.YYYY HH:mm';
